import { render, staticRenderFns } from "./MonitoringClaims.vue?vue&type=template&id=4974adcc&"
import script from "./MonitoringClaims.vue?vue&type=script&lang=js&"
export * from "./MonitoringClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports